module.exports = __webpack_public_path__ + "ClientApp/images/content/Yvonne and Ranger.jpg";